import { Component, OnInit } from '@angular/core';
import { ForeignPermitPaymentsService } from 'src/app/services/transit/foreign-permit-payments.service';

@Component({
  selector: 'app-vehicles-pending-foreign-permit-pmt',
  templateUrl: './vehicles-pending-foreign-permit-pmt.component.html',
  styleUrls: ['./vehicles-pending-foreign-permit-pmt.component.css']
})
export class VehiclesPendingForeignPermitPmtComponent implements OnInit{
  page: number = 1;
  count: number = 0;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  public warningMessage: string | null = null;
  vehicles: any[] = [];
  searchText: string = '';
  public isLoading: boolean = false;

  constructor(
    private foreignPermitPaymentsService:ForeignPermitPaymentsService,
  ){}

  ngOnInit(): void {
    this.isLoading=true;
    this.fetchVehicles();
  }

  fetchVehicles():void{
    this.foreignPermitPaymentsService.getvehiclesPendingForeignPermitPayment()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.vehicles = response.data;
          this.isLoading=false;
        }else if(response.status==='no_data'){
           this.errorMessage=response.message;
           this.isLoading=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isLoading=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isLoading=false;
      }
    });
  }

  pageChangeEvent(event: number){
    this.page = event;
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
    this.page = 1; // Reset to page 1 after applying filter
  }
}
